import { render, staticRenderFns } from "./agents.vue?vue&type=template&id=bca0a992&scoped=true&"
import script from "./agents.vue?vue&type=script&lang=js&"
export * from "./agents.vue?vue&type=script&lang=js&"
import style0 from "./agents.vue?vue&type=style&index=0&id=bca0a992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca0a992",
  null
  
)

export default component.exports